import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {Filter} from "models/Filter"
import {TextModel} from "../../../../models/Text"
import connect from "./connect"

export interface FacetLabelProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    $isOnSecondRow?: boolean
    filterName?: string
    filter: Filter
    text: TextModel
}

const FacetLabel = memo(({templating, $isOnSecondRow, filterName, filter, text}: FacetLabelProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)
    return <ComponentName $isOnSecondRow={$isOnSecondRow} filterName={filterName} filter={filter} text={text} />
})
FacetLabel.displayName = "FacetLabel"

export default connect(FacetLabel)
